<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Video</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>

                <!--<span class="title green&#45;&#45;text text&#45;&#45;darken-3">Fotografije</span>-->
                <!--<v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>-->

                <v-tabs
                        background-color="white"
                        color="primary"
                        right
                >
                    <v-tab>Album</v-tab>
                    <v-tab v-if="photoTab">Video</v-tab>

                    <v-tab-item>
                        <v-row align="center" class="white mt-3 pa-3" no-gutters>
                        <!--NOVA POLJA-->

                        <v-col cols="12" sm="6" class="px-2">
                            <v-autocomplete
                                    clearable
                                    v-model="selectedItem.object"
                                    :items="objects"
                                    outlined
                                    dense
                                    label="Objekat"
                                    outlined
                                    item-value="id"
                                    item-text="name"
                                    return-object
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" class="px-2">
                            <v-select clearable
                                    :items="pages"
                                    v-model="selectedItem.page"
                                    dense
                                    label="Strana"
                                    outlined
                                    item-value="id"
                                    item-text="name"
                                    return-object
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" class="px-2">
                            <v-autocomplete
                                    clearable
                                    v-model="selectedItem.news"
                                    :items="news"
                                    outlined
                                    dense
                                    label="Vest"
                                    outlined
                                    item-value="id"
                                    item-text="name"
                                    return-object
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" class="px-2">
                            <v-autocomplete
                                    clearable
                                    v-model="selectedItem.category"
                                    :items="categories"
                                    outlined
                                    dense
                                    label="Kategorija"
                                    outlined
                                    item-value="id"
                                    item-text="name"
                                    return-object
                            ></v-autocomplete>
                        </v-col>

                        <!-- // NOVA POLJA-->
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12" class="px-2 mt-4">


                            <v-tabs v-model="tab" background-color="primary" dark height="40">
                                <v-tab v-for="item in selectedItem.langs" :key="item.tab">
                                    {{ item.lang.name }}
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item v-for="item in selectedItem.langs" :key="item.tab">
                                    <v-card>
                                        <v-card-text>
                                            <v-row no-gutters>

                                                <v-col cols="12" sm="12" class="px-2">
                                                    <v-text-field
                                                            v-model="item.name"
                                                            dense
                                                            label="Naziv"
                                                            outlined
                                                            @input="seo(item)"
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" class="px-2">
                                                    <v-text-field
                                                            v-model="item.seo_url"
                                                            dense
                                                            label="Seo url"
                                                            outlined
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" class="px-2">
                                                    <v-combobox
                                                            v-model="item.keywords"
                                                            dense
                                                            outlined
                                                            label="Kljucne reci"
                                                            multiple
                                                            small-chips
                                                    ></v-combobox>
                                                </v-col>

                                                <v-col cols="12" sm="12" class="px-2">
                                                    <v-text-field
                                                            v-model="item.meta_description"
                                                            dense
                                                            label="Meta opis"
                                                            outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" class="px-2">
                                                    <v-text-field
                                                            v-model="item.short_description"
                                                            dense
                                                            label="Kratki opis"
                                                            outlined
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" class="px-2">
                                                    <span>Opis</span>
                                                    <ckeditor v-model="item.description" :config="editorConfig"></ckeditor>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>


                        </v-col>
                        <v-col cols="12" class="mt-2">
                            <v-row justify="center">
                                <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                            </v-row>
                        </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>

                        <v-row align="center" class="white mt-3 pa-3" no-gutters>
                            <v-col cols="12">
                                <v-btn
                                        @click="selectedItem.videos.push({video: null, position: null,album_cover: null, video_album_id: null})"
                                        color="primary"
                                        class="mx-1">
                                    Add Video</v-btn>
                                <v-btn
                                        @click="saveVideos"
                                        color="error"
                                        class="mx-1">
                                    Save Video</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" class="px-2">
                                <v-row no-gitters>
                                    <template v-for="(video, index) in selectedItem.videos">
                                        <v-col cols="10">
                                            <v-text-field
                                                    label="URL"
                                                    outlined
                                                    dense
                                                    v-model="video.video"
                                                    hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="2" class="px-4">
                                            <v-row align="center" class="fill-height">
                                                <v-btn outlined color="error" @click="selectedItem.videos.splice(index, 1)">Remove</v-btn>
                                            </v-row>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-tab-item>
                </v-tabs>



        </v-col>

        <v-snackbar v-model="snackbar.status" top>
            {{ snackbar.text }}
            <v-btn
                    color="pink"
                    text
                    @click="snackbar.status = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-dialog
                v-model="dialog"
                max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Image preview</v-card-title>
                <v-card-text>
                    <img :src="dialogImg" width="100%"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="dialog = false"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import bitPage from "../../components/layout/page";
    //import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import axios from 'axios'
    import config from '../../config'
    import { Datetime } from 'vue-datetime';

    export default {
        components: {
            bitPage,
            datetime: Datetime
        },
        head() {
            return {
                title: 'BitLab CMS'
            }
        },
        data: () => ({
            dialog: false,
            dialogImg: null,
            config: config,
            breadcrumbs: [
                {
                    text: 'Video',
                    disabled: false,
                    to: {name: 'video'},
                },
                {
                    text: 'Dodavanje novi Video',
                    disabled: true
                },
            ],
            items: [],
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            //editor: ClassicEditor,
            editorData: '<p>Rich-text editor content.</p>',
            editorConfig: {
                extraPlugins: 'justify'
            },
            selectedItem: {
                position: null,
                parent_id: null,

                langs: []
            },
            tab: null,
            objects: [],
            categories: [],
            pages: [],
            news: [],
            photoTab: false,
            newItem: null,
            uploading: false,
            snackbar: {
                status: false,
                text: null
            }
        }),
        created() {
            if(this.$route.params.item){
                this.selectedItem = this.$route.params.item;
                this.getLangs();
                this.selectedItem.langs.forEach(lang => {
                    return lang.keywords = lang.keywords && lang.keywords.split(',')
                        ? lang.keywords.split(',') : []
                })

                this.photoTab = true
            }
            else{
                this.getLangs();
            }
            this.getObject();
            this.getPage();
            this.getNews();
            this.getCategory();
        },
        methods: {
            getCategory() {
                this.categories = [];
                this.axios.get(`/category/all`)
                    .then(res =>

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.name ? lang.name : '';
                            if (item['name'] !== '') this.categories.push(item)
                        })

                    )
            },
            open(url) {
              this.dialog = true;
              this.dialogImg = url;
            },
            saveVideos() {


                let id = this.$route.params && this.$route.params.item ? this.$route.params.item.id : this.selectedItem.id

                this.selectedItem.videos.forEach(item => {
                    item.video_album_id = id
                })

                this.axios.post('/video', {videos: this.selectedItem.videos}).then(res => {
                    this.selectedItem.videos = res.data
                })

            },
            getLangs() {
                this.$store.dispatch('GET_LANGUAGES').then(res => {
                    res.forEach(lang => {
                        let check = this.selectedItem.langs.find(item => item.lang_id === lang.id)
                        if(!check) {
                            this.selectedItem.langs.push({
                                name: null,
                                seo_url: null,
                                meta_description: null,
                                keywords: null,
                                short_description: null,
                                description: null,
                                lang: lang,
                                lang_id: lang.id,
                                file: null
                            })
                        }
                    })

                    console.log(this.selectedItem)
                })
            },
            getObject() {
                this.axios.get(`/object`)
                    .then(res =>

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.name ? lang.name : '';
                            if (item['name'] !== '') this.objects.push(item)
                        })

                    )
            },
            getPage() {
                this.axios.get(`/page`)
                    .then(res => this.pages = res.data)
            },
            getNews() {
                this.axios.get(`/news`)
                    .then(res => {

                        res.data.forEach(item => {
                            let lang = item.langs.find(lang => lang.lang.lang_code === this.setLang);
                            item['name'] = lang && lang.title ? lang.title : '';
                            if (item['name'] !== '') this.news.push(item)
                        })

                    })
            },
            save() {
                this.selectedItem.object_id = this.selectedItem.object ? this.selectedItem.object.id : null
                this.selectedItem.page_id = this.selectedItem.page ? this.selectedItem.page.id : null
                this.selectedItem.news_id = this.selectedItem.news ? this.selectedItem.news.id : null
                this.selectedItem.category_id = this.selectedItem.category ? this.selectedItem.category.id : null

                if(this.$route.params.item){
                    this.axios.put(`/video-album/${this.$route.params.item.id}`, this.selectedItem).then(res => {
                        this.photoTab = true
                    })
                }
                else{
                    this.axios.post(`/video-album`, this.selectedItem).then(res => {
                        this.selectedItem.id = res.data.data.id;
                        this.selectedItem.photos = []
                        this.photoTab = true;
                    })
                }
            },
            position(image) {
                this.axios.put(`/video-album/${image.id}`, image).then(res => {
                    this.snackbar.text = 'Successfully updated position';
                    this.snackbar.status = true;
                })
            },
            seo(item) {
                item.seo_url = item.name.toLowerCase()
                    .replace(/ /g,'-')
                    .replace(/[^\w-]+/g,'')
            }
        },
        computed: {
            setLang() {
                return this.$store.state.lang.code === 'en'
                    ? 'en' : this.$store.state.lang.code === 'la'
                        ? 'sr' : 'ћи'
            }
        },
        watch: {
            setLang() {
                this.getObject();
            }
        }
    }
</script>
